import axios from 'axios';
import config from '../components/Common_Files/Config';
import $ from "jquery";
import Swal from 'sweetalert2';

const accessToken = localStorage.getItem('accessToken');
let confirmGrnInFlight = false;

export const fetchGRNProducts = async (purchase_id, setGRNItems, setPurchaseData, setBatchData,setStdGoods, setPreSupplierData, setDeliveryAddress, setWarehouseData) => 
{
  $('#purchase_id').val(purchase_id);
  const apiUrl = `${config.api_url}/ws-purchase-item-by-id`;
  let formData = new FormData();
  formData.append('purchase_id', purchase_id);

  try {
    const response = await axios.post(apiUrl, formData, {
      headers: {
        'Authorization': `Bearer ${accessToken}`
      }
    });

    const purchase_item = response.data.purchase_item;
    const initializedGRNItems = purchase_item.map(item => ({
      ...item,
      expiryData: [{ expiryDate: "", batchQty: "" }],
      //  received_qty: 0,
        batchQty: 0,
        newlyAdded: 0
      }));

     //   console.log('hello');
        // console.log(initializedGRNItems);
        // console.log('HI');
        
        setGRNItems(initializedGRNItems);
        setBatchData(response.data.batch_info);
        const purchase = response.data.purchase;
        setPurchaseData(purchase);
       // setStdGoods(purchase.std_goods);
        setPreSupplierData(response.data.purchase.supplier_id);
        
        // Set delivery address state
        if (purchase.delivery_type === 'collection') {
          $('#addr1').val(purchase.address_line1);
          $('#addr2').val(purchase.address_line2);
          $('#city').val(purchase.city);
          $('#country').val(purchase.country);
          $('#postcode').val(purchase.postcode);
          
          setDeliveryAddress({
            addr1: purchase.address_line1 || '',
            addr2: purchase.address_line2 || '',
            city: purchase.city || '',
            state: purchase.state || '',
            country: purchase.country || '',
            postcode: purchase.postcode || ''
          });
        }
        
        if (purchase.is_wharehouse_or_customer === 'warehouse' && purchase.delivery_type === 'delivery') {
          $('#warehouse_name').val(purchase.name);
          $('#wcode').val(purchase.code);
          $('#addr1').val(purchase.address_line1);
          $('#addr2').val(purchase.address_line2);
          $('#city').val(purchase.city);
          $('#state').val(purchase.state);
          $('#country').val(purchase.country);
          $('#postcode').val(purchase.postcode);
          $('#warehouse_id').val(purchase.warehouse_id);
          $('#delivery_type').val(purchase.delivery_type);

          
          // Set warehouse data state
          setWarehouseData({
            warehouse_name: purchase.name || '',
            code: purchase.code || '',
            addr1: purchase.address_line1 || '',
            addr2: purchase.address_line2 || '',
            city: purchase.city || '',
            state: purchase.state || '',
            country: purchase.country || '',
            postcode: purchase.postcode || ''
          });
          
          // Set delivery address state
          setDeliveryAddress({
            addr1: purchase.address_line1 || '',
            addr2: purchase.address_line2 || '',
            city: purchase.city || '',
            state: purchase.state || '',
            country: purchase.country || '',
            postcode: purchase.postcode || ''
          });
        }

        if (purchase.is_wharehouse_or_customer === 'customer' && purchase.delivery_type === 'delivery') {
          $('#addr1').val(purchase.address_line1);
          $('#addr2').val(purchase.address_line2);
          $('#city').val(purchase.city);
          $('#state').val(purchase.state);
          $('#country').val(purchase.country);
          $('#postcode').val(purchase.postcode);
          $('#delivery_type').val(purchase.delivery_type);
          
          // Set delivery address state
          setDeliveryAddress({
            addr1: purchase.address_line1 || '',
            addr2: purchase.address_line2 || '',
            city: purchase.city || '',
            state: purchase.state || '',
            country: purchase.country || '',
            postcode: purchase.postcode || ''
          });
        }

        $('#arrival_date').val(purchase.arrival_date);
        $('#job_ref').val(purchase.job_ref);
        $('#notes').val(purchase.notes);
        
  } catch (error) {
    console.error("Error fetching warehouse data:", error);
    alert("An error occurred while fetching the data.");
  }
};

export const handleChange = async (selectedOption, grnItems, setGRNItems) => {
  const id = selectedOption;
  const found = grnItems.find(element => element.product_id === id);
  if (found !== undefined) {
    Swal.fire({
      title: 'Error!',
      text: 'Product already exists.',
      icon: 'error',
      timer: 1500,
      showConfirmButton: false
    });   
    $('#productList').val('');
    return;
  }

  $('#productList').val('');
  const formData = new FormData();
  formData.append("id", id);
  const apiUrl = `${config.api_url}/ws-get-products-by-id`;

  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        authorization: `Bearer ${accessToken}`,
      },
      body: formData,
    });

    const data = await response.json();
    const newRow = {
      id: data.products[0].id,
      product_desc: data.products[0].product_desc,
      product_id: data.products[0].id,
      code: data.products[0].code,
      pack: data.products[0].pack,
      size: data.products[0].size,
      price: data.products[0].price,
      cost: data.products[0].cost,
      vat: data.products[0].vat,
      current_stock: data.products[0].price,
      vat_percentage : data.products[0].vat,
      order_qty: 0,
      received_qty: 0,
      grn:0,
      newlyAdded: 1,
      expiryData : [
      {
        expiryDate : "",
        batchQty: ""
      }
      ]
    };

    setGRNItems((prevRows) => [...prevRows, newRow]);
    console.log(newRow);
  } catch (error) {
    console.error("Error fetching products data:", error);
  }
};

export const validateConfirmGrnForm = () => {
  const formElement = document.getElementById("confirm_grn");
  if (!formElement) {
    return { valid: false, message: "Form not found." };
  }
  const jobRef = String(new FormData(formElement).get("job_ref") || "").trim();
  if (!jobRef) {
    return { valid: false, message: "Job Ref is required." };
  }
  if (jobRef.length > 50) {
    return { valid: false, message: "Job Ref must be 50 characters or less." };
  }
  return { valid: true };
};

export const handleConfirmGRN = async (e, status, confirmModal,navigateToPOHistory) => {
  e.preventDefault();

  if (confirmGrnInFlight) {
    return;
  }

  const validation = validateConfirmGrnForm();
  if (!validation.valid) {
    Swal.fire({
      title: "Error!",
      text: validation.message,
      icon: "error",
      timer: 2500,
      showConfirmButton: false,
    });
    return;
  }

  confirmGrnInFlight = true;

  try {
    const formElement = document.getElementById("confirm_grn");
    const formData = new FormData(formElement);
    const stdGoods = parseFloat(formData.get('stdGoods')) || 0;
    const zeroGoods = parseFloat(formData.get('zeroGoods')) || 0;
    const vatAmt = parseFloat(formData.get('vatAmt')) || 0;
    const computedGrandTotal = Math.round((stdGoods + zeroGoods + vatAmt) * 100) / 100;
    formData.set('grandTotal', computedGrandTotal.toFixed(2));
    formData.append('status', status);
    const supplierId = formData.get("supplier_id");
    if (!supplierId) {
      Swal.fire({
        title: "Error!",
        text: "Supplier is Required",
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
      });
      confirmGrnInFlight = false;
      return;
    }
    

    Swal.fire({
      title: 'Processing...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const response = await axios.post(
      `${config.api_url}/ws-confirm-grn`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${accessToken}`
        },
      }
      );

    Swal.close();

    if (response.data.success) {
      if (confirmModal.current) {
        const bsModal = window.bootstrap.Modal.getInstance(confirmModal.current);
        if (bsModal) bsModal.hide();
      }
      navigateToPOHistory('/' + response.data.redirect_url);
      return;
    }

    Swal.fire({
      title: "Error!",
      text: response.data.message || "Failed to confirm GRN.",
      icon: "error",
      timer: 2500,
      showConfirmButton: false,
    });
    
  } catch (error) {
    Swal.close();
    Swal.fire({
      title: "Error!",
      text: error.response?.data?.message || "An error occurred while confirming grn.",
      icon: "error",
        timer: 2500,
        showConfirmButton: false,
      });
  } finally {
    confirmGrnInFlight = false;
  }
};

export const handleInputChange = (e, id, grn, field, setGRNItems, grnItems, newlyAdded , order_qty) => 
{
  const value = parseInt(e.target.value) + parseInt(grn);

  console.log(value);

  if(!newlyAdded)
  {
    let a = 0;
    const  initializedItems = grnItems.map((item) => {
      if (item.id !== id || value > order_qty) {
        return item; 
      }
      
      a = 1; 
      return {
        ...item,
        received_qty: value
      };
    });
    
    if (a === 0) 
    {
      Swal.fire({
        title: "Error!",
        text: "Please enter received quantity less than or equal to grn",
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
      }).then(() => { e.target.value = ''; });
    } else 
    {
      setGRNItems(initializedItems); 
    }
  }
};

export const calculateValue = (quantity, price) => {
  return quantity && price ? quantity * price : 0;
};

export const acceptNumber = (value) => {
  return value.replace(/[^0-9.]/g, "");

  
};